<template>
    <div
        class="d-flex flex-column flex-grow-1"
        style="height: 100%; min-height: 0"
    >
        <p v-if="isLoading" class="flex-shrink-0">Loading...</p>

        <!-- Admin View -->
        <AdminDashboard v-if="!isLoading && canViewAdminDashboard" />

        <!-- Team Lead View -->
        <TeamLeadDashboard v-if="!isLoading && canViewTeamLeadDashboard" />

        <!-- Operator View -->
        <OperatorDashboard
            ref="operatorDashboard"
            v-if="!isLoading && canViewOperatorDashboard"
        />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import OperatorDashboard from "@/components/OperatorDashboard.vue";
import TeamLeadDashboard from "@/components/TeamLeadDashboard.vue";
import AdminDashboard from "@/components/AdminDashboard.vue";

export default {
    name: "UserDashboard",
    components: {
        OperatorDashboard,
        TeamLeadDashboard,
        AdminDashboard,
    },
    computed: {
        ...mapGetters(["getUser", "getRights", "isLoading"]),
        // Define computed properties based on rights
        canViewAdminDashboard() {
            return this.getRights?.viewAdminDashboard || false;
        },
        canViewTeamLeadDashboard() {
            return this.getRights?.viewTeamLeadDashboard || false;
        },
        canViewOperatorDashboard() {
            return this.getRights?.viewOperatorDashboard || false;
        },
    },
};
</script>
